import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  name: string,
  description: string,
  status: number,
  handleNameChange: (v: string) => void,
  handleDescriptionChange: (v: string) => void,
  handleStatusSelection: (x: number) => void,
  handleClearFilters: () => void,
};

export const Header = ({
  name,
  description,
  status,
  handleNameChange,
  handleDescriptionChange,
  handleStatusSelection,
  handleClearFilters,
}: Props) => {
  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense ">
            <DefaultInput
              label="Pesquisar por nome"
              name="search_by_name"
              value={name}
              onChangeValue={handleNameChange} />

            <DefaultInput
              label="Pesquisar por descrição"
              name="search_by_description"
              value={description}
              onChangeValue={handleDescriptionChange} />

            <FormControl size="small" fullWidth>
              <InputLabel id="modulo-dashboard">Status</InputLabel>
              <Select
                labelId="modulo-dashboard"
                label="Status"
                value={status}
                onChange={async (x) => handleStatusSelection(x.target.value as number)}>
                <MenuItem value={0}>Todos</MenuItem>
                <MenuItem value={1}>Ativos</MenuItem>
                <MenuItem value={2}>Bloqueados</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}